import styles from "./Navbar.module.scss";
import { AiOutlineMenu } from "react-icons/ai";
import AvatarNavBar from "./AvatarNavBar";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";
import SearchBar from "./SearchBar";
export default function Navbar({
  clickHandler,
  sidebarVs,
  notification,
  setNotification,
  unseen,
}) {
  const matches = useMediaQuery("(min-width:1200px)");
  return (
    <div
      className={`${styles.navbar} ${sidebarVs ? `` : `${styles.invisible}`}`}
    >
      {/* <Tooltip title="Prace w trakcie" followCursor placement="top"> */}
      <SearchBar />
      {/* </Tooltip> */}
      <div className={styles.icons}>
        {!matches && (
          <IconButton>
            <AiOutlineMenu onClick={clickHandler} />
          </IconButton>
        )}
        {/* <Tooltip title="Prace w trakcie" followCursor placement="top">
          <IconButton>
            <BsChatDots />
          </IconButton>
        </Tooltip> */}
      </div>
      <AvatarNavBar
        unseen={unseen}
        notification={notification}
        setNotification={setNotification}
        dashboard={true}
      />
    </div>
  );
}
